import { render, staticRenderFns } from "./ProfileInput.vue?vue&type=template&id=28b5354b&scoped=true"
import script from "./ProfileInput.vue?vue&type=script&lang=js"
export * from "./ProfileInput.vue?vue&type=script&lang=js"
import style0 from "./ProfileInput.vue?vue&type=style&index=0&id=28b5354b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5354b",
  null
  
)

export default component.exports